export { default as UrlAliasList } from './UrlAliasList';
export { default as UrlAliasEdit } from './UrlAliasEdit';
export { default as UrlAliasCreate } from './UrlAliasCreate';



// WEBPACK FOOTER //
// ./src/modules/UrlAlias/pages/index.ts